export const Constants = {
    cached_goods : "Goods_15_march_2025",
    goods_data_db: "Goods_15_march_2025",
    old_cache: [
        "cachedGoods",
        "newCachedGoods",
        "cacheHDImages",
        "cachedGood",
        "newGoods",
        "goods",
        "Goods_2906",
        "Goods_26_sep",
        "Goods_23_sep_2024"
    ],
    takeDataFromFirebase: false
}